import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import { useTranslation } from '../../i18n';

const AccessPreviewBanner = () => {
  const { preview, stopPreview } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!preview || preview.frame) return null;

  const exit = () => {
    const groupId = preview.groupId;
    stopPreview();
    navigate(`/permission-control?group=${groupId}`);
  };

  return (
    <div
      role="status"
      className="fixed z-[1000] left-1/2 -translate-x-1/2 bottom-4 max-w-[calc(100%-2rem)] flex flex-wrap items-center gap-x-3 gap-y-1 rounded-full bg-blue-700 text-white shadow-lg px-4 py-2 text-sm"
    >
      <FaEye aria-hidden="true" />
      <span>
        {t('Viewing as')} <strong>{preview.groupName}</strong>
      </span>
      <span className="text-blue-100 hidden sm:inline">{t('Pages, cards and buttons only; data is not filtered.')}</span>
      <button
        type="button"
        onClick={exit}
        className="rounded-full bg-white text-blue-700 font-semibold px-3 py-0.5 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {t('Exit')}
      </button>
    </div>
  );
};

export default AccessPreviewBanner;
